import {
  PrimaryBigButton,
  SecondaryBigButton
} from 'components/ReusableComponents/Button/BigButtons'
import ClockIcon from 'components/ReusableComponents/Icons/Clock'
import SendIcon from 'components/ReusableComponents/Icons/Send'
import { useEngagePlusGate } from 'components/ReusableComponents/UnlockServiceDialog'
import PropTypes from 'prop-types'

import styles from './SendMessageBar.module.scss'

const SendMessageBar = ({ onClickMessageNow, onClickSchedule, canSendMessageNow }) => {
  const { promptEngagePlusUpgrade } = useEngagePlusGate()

  return (
    <div className={styles.bar}>
      <SecondaryBigButton
        onClick={() => {
          if (!promptEngagePlusUpgrade()) {
            onClickSchedule()
          }
        }}
      >
        <ClockIcon width="20" height="17" />
        Schedule a message
      </SecondaryBigButton>
      <PrimaryBigButton
        onClick={() => {
          if (!promptEngagePlusUpgrade()) {
            onClickMessageNow()
          }
        }}
        disabled={!canSendMessageNow}
      >
        <SendIcon width="22" height="22" /> Message now
      </PrimaryBigButton>
    </div>
  )
}

SendMessageBar.propTypes = {
  onClickMessageNow: PropTypes.func,
  onClickSchedule: PropTypes.func,
  canSendMessageNow: PropTypes.bool
}

export default SendMessageBar
